import { useState, useEffect } from "react";
import { useGeocodingService } from "@ubilabs/google-maps-react-hooks";
import { getAlcadiaByCP } from "../../../../../../../utils/getAlcadiaByCP";

const parsearComponentes = (components, latLng) => {
  const datos = {
    direccionCompleta: "",
    lat: latLng.lat,
    lng: latLng.lng,
    cp: "",
    estado: "",
    municipio: "",
    pais: "",
  };

  components.forEach((component) => {
    const types = component.types;
    if (types.includes("postal_code")) datos.cp = component.long_name;
    if (types.includes("administrative_area_level_1")) datos.estado = component.long_name;
    if ((types.includes("locality") || types.includes("administrative_area_level_2")) && !datos.municipio) {
      datos.municipio = component.long_name;
    }
    if (types.includes("country")) datos.pais = component.long_name;
  });

  if (datos.estado === "Ciudad de México" && datos.cp) {
    const alcaldia = getAlcadiaByCP(datos.cp);
    if (alcaldia) datos.municipio = alcaldia;
  }

  return datos;
};

export const useGeocoding = (latLng, { onDireccionChange, onLoadingChange } = {}) => {
  const [direccion, setDireccion] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const geocoder = useGeocodingService();

  const setLoading = (val) => {
    setIsLoading(val);
    onLoadingChange?.(val);
  };

  useEffect(() => {
    if (!geocoder) return;

    setLoading(true);

    const timeoutId = setTimeout(() => {
      geocoder.geocode({ location: latLng }, (results, status) => {
        setLoading(false);

        if (status !== "OK" || !results?.length) {
          console.error(`Error al geolocalizar: ${status}`);
          return;
        }

        const resultado = results[0];
        const datos = parsearComponentes(resultado.address_components, latLng);
        datos.direccionCompleta = resultado.formatted_address;

        setDireccion(datos);
        onDireccionChange?.(datos);
      });
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [latLng.lat, latLng.lng, geocoder]);

  return { direccion, isLoading };
};
